export const useSearchFiltersOptionsEquipments = () => {
  const equipementPerCategory: Record<'inside' | 'outside' | 'driving' | 'safety' | 'winter', string[]> = getEquipmentCategories()

  const { getTranslatedVehicleEquipment } = useGetTranslatedVehicleEquipment()
  const { getTranslatedVehicleEquipmentCategory } = useGetTranslatedVehicleEquipmentCategory()

  const equipmentsCategories = computed(() => {
    return Object.fromEntries(
      Object.entries(equipementPerCategory).map(([cat, options]) => ([cat, {
        title: getTranslatedVehicleEquipmentCategory(cat),
        options: options.map(value => ({
          text: getTranslatedVehicleEquipment(value),
          value,
        })),
      }]),
      ))
  })

  return {
    equipmentsCategories,
  }
}
